import NotFound from 'components/NotFound';
import Staff from 'components/Staff/Staff';
import AdminBilling from 'components/admin/pages/Practices/Billing/AdminBilling';
import FacilityProvider from 'components/admin/pages/Practices/Facility/FacilityProvider';
import AdminFormBuilder from 'components/admin/pages/Practices/FormBuilder/AdminFormBuilder';
import AdminPracticesOrganization from 'components/admin/pages/Practices/Organization/Organization';
import PracticeOverviewContainer from 'components/admin/pages/Practices/OverviewContainer';
import PatientImport from 'components/admin/pages/Practices/PatientImport';
import PracticePatients from 'components/admin/pages/Practices/Patients/Patients';
import PracticesTable from 'components/admin/pages/Practices/PracticesTable';
import Settings from 'components/admin/pages/Practices/Settings/Settings';
import CheckInStepsSettings from 'components/admin/pages/Practices/Settings/components/CheckInSteps';
import ClinicalNotesSettings from 'components/admin/pages/Practices/Settings/components/ClinicalNotes';
import FormsSettings from 'components/admin/pages/Practices/Settings/components/Forms';
import PatientCommunicationSettings from 'components/admin/pages/Practices/Settings/components/PatientCommunication';
import SelfSchedulingSettings from 'components/admin/pages/Practices/Settings/components/SelfScheduling';
import TerminalManagement from 'components/admin/pages/Practices/Terminals/TerminalManagement';
import AdminPracticesTransactions from 'components/admin/pages/Practices/Transaction/Transactions';
import AdminForms from 'components/admin/pages/Practices/forms';
import EditFormBuilderContainer from 'components/admin/pages/Practices/forms/FormEditContainer';
import NewFormBuilderContainer from 'components/admin/pages/Practices/forms/new_container';
import PracticeProfile from 'components/admin/pages/Practices/profile';
import AdminStaff from 'components/admin/pages/Practices/staff';
import KioskSettings from 'components/practice/Settings/components/Kiosks/KioskSettings';
import Roles from 'components/shared/Roles-new/Roles';

const ADMIN_PRACTICES = [
  {
    path: 'practices',
    element: <PracticesTable />,
    children: [
      {
        path: ':id',
        element: <PracticeProfile />,
        children: [
          {
            path: '',
            element: <PracticeOverviewContainer />
          },
          {
            path: 'staff',
            element: <AdminStaff />
          },
          {
            path: 'patients',
            element: <PracticePatients />
          },
          {
            path: 'forms',
            element: <AdminForms />,
            children: [
              {
                path: 'create',
                element: <NewFormBuilderContainer />
              },
              {
                path: 'edit/:formId',
                element: <EditFormBuilderContainer />
              },
              {
                path: '*',
                element: <NotFound />
              }
            ]
          },
          {
            path: 'settings',
            element: <Settings />,
            children: [
              {
                path: 'forms',
                element: <FormsSettings />
              },
              {
                path: 'patient-communication',
                element: <PatientCommunicationSettings />
              },
              {
                path: 'clinical-notes',
                element: <ClinicalNotesSettings />
              },
              {
                path: 'check-in-steps',
                element: <CheckInStepsSettings />
              },
              {
                path: 'self-scheduling-steps',
                element: <SelfSchedulingSettings />
              }
            ]
          },
          {
            path: 'terminals',
            element: <TerminalManagement />
          },
          {
            path: 'roles',
            element: <Roles isAdmin />
          },
          {
            path: 'staff-management',
            element: <Staff />
          },
          {
            path: 'kiosk',
            element: <KioskSettings />
          },
          {
            path: 'patient-import',
            element: <PatientImport />
          },
          {
            path: 'billing',
            element: <AdminBilling />
          },
          {
            path: 'facility',
            element: <FacilityProvider />
          },
          {
            path: 'transactions',
            element: <AdminPracticesTransactions />
          },
          {
            path: 'organization',
            element: <AdminPracticesOrganization />
          },
          {
            path: 'form-builder',
            element: <AdminFormBuilder />
          },
          {
            path: '*',
            element: <NotFound />
          }
        ]
      },
      {
        path: '*',
        element: <NotFound />
      }
    ]
  }
];
export default ADMIN_PRACTICES;
